import { render, staticRenderFns } from "./chmain.vue?vue&type=template&id=508e4284&scoped=true"
import script from "./chmain.vue?vue&type=script&lang=js"
export * from "./chmain.vue?vue&type=script&lang=js"
import style0 from "./chmain.vue?vue&type=style&index=0&id=508e4284&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e4284",
  null
  
)

export default component.exports